import { QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import { Toaster } from 'sonner';

import { ThemeProvider } from '@/components/theme-provider';
import { TooltipProvider } from '@/components/ui/tooltip';
// A megosztott (modul-szintű) példány — a route-guard is ezt használja a React-fán kívül.
import { queryClient } from '@/lib/query-client';
import '@/i18n';

/** Globális providerek egy helyen — a gyökér-route ezzel csomagolja az egész appot. */
export function AppProviders({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider delayDuration={200}>
          {children}
          {/* Jobb alul (iparági standard): nem takarja a topbart/műveleteket, a periférián jelenik meg */}
          <Toaster richColors position="bottom-right" />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
